module.exports = __webpack_public_path__ + "img/MX-C150093A-BS-HQ.fce68bb1.png";